module.exports = __webpack_public_path__ + "img/qrcode_qyxcx.4c6c0d4f.jpg";